import React, { FC } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { TColumnHeadingElement } from '../../types/index.types';
import Picture from '../../../@shared/picture';

const ColumnHeadingElement: FC<TColumnHeadingElement> = (props) => {
  if (!props.colHeadings?.length) return null;
  return (
    <>
      {props.colHeadings
        ?.filter((_, columnIndex) => {
          if (!props.showHiddenRightCells) return columnIndex <= 5;
          return true;
        })
        .map((val) => {
          const text = val?.text;
          const image = val?.image;
          return (
            <th>
              <div className="model-detail-specification-table__col-heading-dropdown__wrapper">
                {!props.isHideImage && (
                  <Picture
                    editorialImageProps={{
                      desktopImage: image,
                      alt: image?.value?.alt as string,
                      cssClassPictureEl: 'model-detail-specification-table__col-heading--picture',
                      cssClassImageEl: 'model-detail-specification-table__col-heading--image',
                      desktopTransformation: 'Size500',
                      mobileTransformation: 'Size300',
                    }}
                  />
                )}
                <div
                  className={`model-detail-specification-table__col-heading ${
                    props.isHideImage ? '' : 'model-detail-specification-table__col-heading--title-image'
                  }`}
                >
                  {!!text && <Text field={text} editable={true} />}
                </div>
              </div>
            </th>
          );
        })}
    </>
  );
};

export default ColumnHeadingElement;
